module.exports = __webpack_public_path__ + "static/media/slider1.cdd3fd2c.jpg";